import { useState, useRef } from 'react';

const LOADING_DELAY = 200;

export function useLoading() {
    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState<NodeJS.Timeout | undefined>(undefined);
    const shouldCancelRef = useRef(false);

    const startLoading = () => {

        clearTimeout(timer);
        shouldCancelRef.current = false;

        const newTimer = setTimeout(() => {
            if (!shouldCancelRef.current) {
                setLoading(true);
            }
        }, LOADING_DELAY);

        setTimer(newTimer);
    }

    const stopLoading = () => {
        shouldCancelRef.current = true;
        clearTimeout(timer);
        setLoading(false);
        setTimer(undefined);
    }

    return { loading, startLoading, stopLoading };
}